import React from 'react';

import ProjectBrandCard from '@/features/project-management-tools/components/ProjectBrandCard';
import LoaderComponent from '@/components/LoaderComponent';
import NoData from '@/components/NoData';

const ProjectCardsView = ({ projectCardView, projectLoading }) => {
	return (
		<LoaderComponent loading={projectLoading}>
			<div className="task-list-container project-list-container">
				<div className="task-all-row d-grid gap-5 grid-columns-4">
					{projectCardView?.map(
						(item) =>
							(item?.statusMap?.PENDING || item?.statusMap?.RUNNING) && (
								<ProjectBrandCard
									key={item?.brandResponse?.id}
									brandResponse={item?.brandResponse}
									statusMap={item?.statusMap}
								/>
							)
					)}
				</div>
				{projectCardView?.length === 0 && (
					<div className="d-flex justify-content-center align-items-center">
						<NoData message={'No project found'} />
					</div>
				)}
			</div>
		</LoaderComponent>
	);
};

export default ProjectCardsView;
